var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarDate = function SvgCalendarDate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 4.125C0.75 3.08947 1.58947 2.25 2.625 2.25H15.375C16.4105 2.25 17.25 3.08947 17.25 4.125V15.375C17.25 16.4105 16.4105 17.25 15.375 17.25H2.625C1.58947 17.25 0.75 16.4105 0.75 15.375V4.125ZM2.625 3.75C2.41789 3.75 2.25 3.91789 2.25 4.125V15.375C2.25 15.5821 2.41789 15.75 2.625 15.75H15.375C15.5821 15.75 15.75 15.5821 15.75 15.375V4.125C15.75 3.91789 15.5821 3.75 15.375 3.75H2.625Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 0.75C6.03921 0.75 6.375 1.08579 6.375 1.5V4.5C6.375 4.91421 6.03921 5.25 5.625 5.25C5.21079 5.25 4.875 4.91421 4.875 4.5V1.5C4.875 1.08579 5.21079 0.75 5.625 0.75Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 0.75C12.7892 0.75 13.125 1.08579 13.125 1.5V4.5C13.125 4.91421 12.7892 5.25 12.375 5.25C11.9608 5.25 11.625 4.91421 11.625 4.5V1.5C11.625 1.08579 11.9608 0.75 12.375 0.75Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38444 7.67675C5.78164 7.10594 6.45741 6.75 7.20036 6.75C8.34231 6.75 9.37507 7.61668 9.37507 8.8125C9.37507 9.88354 8.5336 11.0625 7.12507 11.0625C6.71085 11.0625 6.37507 10.7267 6.37507 10.3125C6.37507 9.89829 6.71085 9.5625 7.12507 9.5625C7.57533 9.5625 7.87507 9.19121 7.87507 8.8125C7.87507 8.55858 7.6321 8.25 7.20036 8.25C6.93512 8.25 6.72499 8.37643 6.61569 8.53351C6.3791 8.87351 5.91169 8.95734 5.57169 8.72076C5.23169 8.48417 5.14786 8.01675 5.38444 7.67675Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95108 9.58292C8.44966 9.22588 9.7499 10.4389 9.7499 11.8125C9.7499 13.198 8.57436 14.25 7.21451 14.25C6.25121 14.25 5.39501 13.7304 4.9657 12.9393C4.76814 12.5752 4.90312 12.1199 5.26719 11.9224C5.63125 11.7248 6.08654 11.8598 6.2841 12.2238C6.44659 12.5233 6.7919 12.75 7.21451 12.75C7.82675 12.75 8.2499 12.291 8.2499 11.8125C8.2499 11.3221 7.773 10.9291 7.29872 11.0421C6.89578 11.1381 6.49132 10.8893 6.39532 10.4863C6.29932 10.0834 6.54814 9.67892 6.95108 9.58292Z",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 7.5C10.125 7.08579 10.4608 6.75 10.875 6.75H12.375C12.7892 6.75 13.125 7.08579 13.125 7.5V13.5C13.125 13.9142 12.7892 14.25 12.375 14.25C11.9608 14.25 11.625 13.9142 11.625 13.5V8.25H10.875C10.4608 8.25 10.125 7.91421 10.125 7.5Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-date.6f2fb9a5.svg";
export { ForwardRef as ReactComponent };